import { useQuery } from 'react-query';
import { getClientDataFiles } from 'api/downloads';
import { getPartyId } from 'utils/partyId/setPartyId';
import { isLoggedInAsObserver } from 'auth/utils';

const useQueryClientDataDownloadFiles = () => {
  const isObserver: boolean = isLoggedInAsObserver();
  let isCallEnabled: boolean = true;

  if (isObserver) {
    const partyId: string | null = getPartyId();
    isCallEnabled = !!partyId;
  }

  return useQuery(['CVS-download-list'], () => getClientDataFiles(), { enabled: isCallEnabled });
};

export { useQueryClientDataDownloadFiles };
